import Head from './TopHead';
import Curric from './Curric';

function PowerPoint() {
    return (
        <main>
            <Head />

            <h1>Microsoft PowerPoint (365)</h1>

            <section className="section">
            <h2>PowerPoint Fundamental Skills: 2 Levels</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Microsoft PowerPoint - Level 1 (3 Hours)">
                    <div className="expect">
                        <b>What to Expect:</b> You'll learn how to perform everyday office tasks in PowerPoint.
                    </div>
                    <ul>
                        <li>Create and Save a Basic Presentation</li>
                        <li>Add & Manage Slides</li>
                        <li>Design a Presentation</li>
                        <li>Insert & Format Text</li>
                        <li>Insert & Format Images</li>
                        <li>Unsplash, Pexels</li>
                        <li>Insert & Format Shapes</li>
                        <li>Size, Group, and Arrange Objects</li>
                        <li>Align Items, Distribute Items, Lock, Hide, Selection Panel</li>
                        <li>Ctrl D, Ctrl G, Shift</li>
                        <li>Heading, Body fonts</li>
                        <li>Theme Fonts vs Regular Fonts</li>
                        <li>Theme Colors vs Regular Colors</li>
                        <li>Add a Table</li>
                        <li>Create SmartArt</li>
                        <li>Insert Stock Media & Icons</li>
                        <li>Add Screenshots</li>
                        <li>Add Charts</li>
                        <li>Review Your Presentation</li>
                        <li>Comments & Notes</li>
                        <li>Print or Export a Presentation</li>
                        <li>Deliver Your Presentation</li>
                    </ul>
                    <div className="prerequisites"><b>Prerequisites:</b> Basic computer skills, including saving and
                        locating files.</div>
                    </Curric>

                    <Curric title="Microsoft PowerPoint - Level 2 [Create Great Looking Presentations] (3 Hours)">
                    <div className="expect">
                        <b>What to Expect:</b> You'll learn techniques to create great looking presentations, anymations
                        and link your presentataions to Excel files.
                    </div>
                    <ul>
                        <li>Merge Shapes</li>
                        <li>Create Advanced Shapes</li>
                        <li>Work With Images</li>
                        <li>Images in Shapes</li>
                        <li>Overlay Image, Picture on Picture</li>
                        <li>Text on Picture, Letter Spacing</li>
                        <li>Lock Aspect Ratio</li>
                        <li>Eyedropper & Format Painter</li>
                        <li>Slidemaster View</li>
                        <li>Modify Slidemaster</li>
                        <li>Pro Tricks With Placeholders & Images</li>
                        <li>Pro Tricks With Placeholders & Text</li>
                        <li>Pro Tricks With SVG</li>
                        <li>Linked Charts With Excel Files</li>
                        <li>Animations & Transitions</li>
                        <li>Spectacular Morph Effects</li>
                    </ul>
                    <div className="prerequisites"><b>Prerequisites:</b> Must know PowerPoint basics.</div>
                    </Curric>
                </div>
            </section>

            <hr />

        </main>

    );
}

export default PowerPoint;